(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("PolarisVue", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["PolarisVue"] = factory(require("vue"));
	else
		root["PolarisVue"] = factory(root["vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_258__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition